import { SwitchWithLabel } from "./switch-with-label"

export const SwitchMyPositions = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return <SwitchWithLabel label="My Positions" checked={checked} onCheckedChange={onCheckedChange} />
}
